import React from 'react';
import '../styles.css'; // Ensure base styles are imported

export default function LoadingSpinner() {
    return (
        <div className="loading-spinner-container">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
        </div>
    );
}
